import React from 'react';
import { 
  TopNavigation,
  ButtonDropdown,
  Button,
  Box
} from '@amzn/awsui-components-console';
import { useNavigate } from 'react-router-dom';
import AmazonLogo from '../../images/amazon-logo.svg';
import './Header.scss';

interface HeaderProps {
  userName?: string;
  displayName?: string;
  applicationName?: string;
  onSignOut?: () => void;
  onUserMenuClick?: (event: any) => void;
}

const Header: React.FC<HeaderProps> = ({ 
  userName = '', 
  displayName = '',
  applicationName = 'ADDAPT',
  onSignOut,
  onUserMenuClick
}) => {
  const navigate = useNavigate();
  const [signOutTriggered, setSignOutTriggered] = React.useState(false);

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleUserMenuClick = async (event: any) => {
    const { id } = event.detail;
    
    if (id === 'signout') {
      setSignOutTriggered(true);
      if (onSignOut) {
        await onSignOut();
      }
      setSignOutTriggered(false);
    } else if (onUserMenuClick) {
      onUserMenuClick(event);
    }
  };

  return (
    <header id="header" className="addapt-header">
      <TopNavigation
        identity={{
          href: "#",
          title: applicationName,
          logo: {
            src: AmazonLogo,
            alt: "Amazon"
          },
          onFollow: (event) => {
            event.preventDefault();
            handleLogoClick();
          }
        }}
        utilities={[
          {
            type: "button",
            text: "Documentation",
            href: "https://w.amazon.com",
            external: true,
            externalIconAriaLabel: " (opens in a new tab)"
          },
          {
            type: "button",
            iconName: "notification",
            title: "Notifications",
            ariaLabel: "Notifications (0 unread)",
            badge: false,
            onClick: () => {
              {}
            }
          },
          {
            type: "button",
            iconName: "settings",
            title: "Settings",
            ariaLabel: "Settings",
            onClick: () => {
              {}
            }
          },
          {
            type: "menu-dropdown",
            iconName: "user-profile",
            text: displayName || userName,
            description: userName,
            onItemClick: handleUserMenuClick,
            items: [
            
              {
                id: "signout",
                text: "Sign out",
                iconName: "undo"
              }
            ]
          }
        ]}
      />
    </header>
  );
};

export default Header;
